import {
    DeleteOutlined,
    ExclamationCircleOutlined,
    EyeOutlined,
} from "@ant-design/icons";
import { Button, Col, Image, Modal, Tag, Spin } from "antd";
import { useEffect, useState } from "react";
import { authApis } from "../../../services/authApi";
import Paginate from "../../../commons/Paginate";
import MainLayout from "../../../components/mainLayout";
import "./index.scss";
import { ROOT_URL } from "../../../constants/api";
import { Link } from "react-router-dom";
import { nofication } from "../../../commons/Nofication";
import parse from "html-react-parser";
import moment from 'moment';

const Register = () => {
    const [newsList, setNewsList] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [paginateCurrent, setPaginateCurrent] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, [paginateCurrent, perPage, searchValue]);

    const fetchData = () => {
        const urlParams = `page=${paginateCurrent}&perPage=${perPage}&search=${searchValue}`;
        authApis
            .getApplyList(urlParams)
            .then((data) => {
                setNewsList(data.applies.data ?? []);
                setTotalItem(data.applies.total ?? 0);
                setIsLoading(false);
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Lấy danh sách ứng tuyển thất bại");
            });
    };

    const onDelete = (id) => {
        authApis
            .deleteApply(id)
            .then((data) => {
                nofication("success", "Thành công!", "Xóa ứng tuyển thành công!");
                fetchData();
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Xóa ứng tuyển thất bại");
            });
    };
    const onConfirmDelete = (id) => {
        Modal.confirm({
            title: "Confirm",
            icon: <ExclamationCircleOutlined />,
            content: "Bạn có muốn xóa?",
            okText: "Ok",
            cancelText: "Cancel",
            onOk: () => {
                onDelete(id);
            },
            onCancel() {
                return;
            },
        });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title=""
            link="/tuyen-dung/list-apply"
            titleNew="Danh sách ứng tuyển"
            setSearchValue={setSearchValue}
        >
            <Spin spinning={isLoading}>
                <Col span={24} className="main-min-height-table">
                    <div
                        style={{
                            width: "100%",
                            margin: "20px 10px 0px 0px",
                            padding: "20px",
                            borderTopRightRadius: "10px",
                            borderTopLeftRadius: "10px",
                            background: "white",
                        }}
                        className="table"
                    >
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col">No</th>
                                    <th scope="col">Họ tên</th>
                                    <th scope="col">Email</th>
                                    <th scope="col">Số điện thoại</th>
                                    <th scope="col">Vị trí ứng tuyển</th>
                                    <th scope="col">Ngày sinh</th>
                                    <th scope="col">Trạng thái</th>
                                    <th scope="col">Ngày ứng tuyển</th>
                                    <th scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {newsList.length ? (
                                    newsList.map((item, index) => {
                                        const getStatusColor = (status) => {
                                            switch (status) {
                                                case 'pending':
                                                    return 'orange';
                                                case 'reviewed':
                                                    return 'blue';
                                                case 'accepted':
                                                    return 'green';
                                                case 'rejected':
                                                    return 'red';
                                                default:
                                                    return 'default';
                                            }
                                        };

                                        const getStatusText = (status) => {
                                            switch (status) {
                                                case 'pending':
                                                    return 'Chờ xử lý';
                                                case 'reviewed':
                                                    return 'Đã xem xét';
                                                case 'accepted':
                                                    return 'Đã chấp nhận';
                                                case 'rejected':
                                                    return 'Đã từ chối';
                                                default:
                                                    return status;
                                            }
                                        };

                                        return (
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <th scope="row">
                                                    {item.full_name}
                                                </th>
                                                <td>{item.email}</td>
                                                <td>{item.phone}</td>
                                                <td>{item.position}</td>
                                                <td>{moment(item.birth_date).format('DD/MM/YYYY')}</td>
                                                <td>
                                                    <Tag color={getStatusColor(item.status)}>
                                                        {getStatusText(item.status)}
                                                    </Tag>
                                                </td>
                                                <td>{moment(item.created_at).format('DD/MM/YYYY HH:mm')}</td>
                                                
                                                <td>
                                                    <Link
                                                        to={`/tuyen-dung/detail/${item.id}`}
                                                    >
                                                        <Button
                                                            icon={
                                                                <EyeOutlined />
                                                            }
                                                            style={{
                                                                color: "white",
                                                                background:
                                                                    "black",
                                                                border: "black",
                                                            }}
                                                            title="Xem chi tiết"
                                                        ></Button>
                                                    </Link>
                                                    <Button
                                                        icon={
                                                            <DeleteOutlined />
                                                        }
                                                        onClick={() =>
                                                            onConfirmDelete(
                                                                item.id
                                                            )
                                                        }
                                                        style={{
                                                            color: "white",
                                                            background:
                                                                "#ab1a1a",
                                                            border: "#ab1a1a",
                                                            marginLeft: 10,
                                                        }}
                                                        title="Xóa"
                                                    ></Button>
                                                </td>
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        {isLoading === false ? (
                                            <td colspan="10">
                                                <h4
                                                    style={{
                                                        textAlign: "center",
                                                        margin: "20px 0px",
                                                    }}
                                                >
                                                    (No data)
                                                </h4>
                                            </td>
                                        ) : (
                                            <></>
                                        )}
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            padding: "20px",
                            background: "white",
                            borderBottomRightRadius: "10px",
                            borderBottomLeftRadius: "10px",
                        }}
                    >
                        <Paginate
                            setPaginateCurrent={setPaginateCurrent}
                            setPerPage={setPerPage}
                            totalItem={totalItem}
                            currentPage={paginateCurrent}
                        />
                    </div>
                </Col>
            </Spin>
        </MainLayout>
    );
};

export default Register;
